export default __webpack_public_path__ + "static/media/ArrowDownIcon.7b0f331f.svg";